export default "__VITE_ASSET__CML98yTR__"